module.exports = __webpack_public_path__ + "static/7csm_ACO_Spin_krovni_slivnici_od_livenog_gvozdja-f7a132556f030c8ee8832c16aa9216e3.jpg";